/**
 * ModuleMD PatientPortal API
 * ModuleMD PatientPortal API service
 *
 * OpenAPI spec version: 1.0.0
 * Contact: emrsupport@modulemd.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs/Observable';

import { PatientPortalLoggedInUserList } from '../model/patientPortalLoggedInUserList';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { debounce } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { request } from 'http';

@Injectable()
export class GetUsersService {

    protected basePath = environment.appSetting.apiUrl + 'patientportal';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Referenced to SOA.GetUsers
     * This API get Users
     * @param userName userName
     * @param password password
     * @param practiceCode practiceCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUsers(userName: string, password: string, practiceCode: string, observe?: 'body', reportProgress?: boolean): Observable<Array<PatientPortalLoggedInUserList>>;
    public getUsers(userName: string, password: string, practiceCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PatientPortalLoggedInUserList>>>;
    public getUsers(userName: string, password: string, practiceCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PatientPortalLoggedInUserList>>>;
    public getUsers(userName: string, password: string, practiceCode: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (userName === null || userName === undefined) {
            throw new Error('Required parameter userName was null or undefined when calling getUsers.');
        }

        if (password === null || password === undefined) {
            throw new Error('Required parameter password was null or undefined when calling getUsers.');
        }
        if (practiceCode === null || practiceCode === undefined) {
            throw new Error('Required parameter practiceCode was null or undefined when calling getUsers.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (userName !== undefined && userName !== null) {
            queryParameters = queryParameters.set('userName', <any>userName);
        }
        if (password !== undefined && password !== null) {
            queryParameters = queryParameters.set('password', <any>password);
        }
        let headers = new HttpHeaders();
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
         return this.httpClient.get<Array<PatientPortalLoggedInUserList>>(`${this.basePath}/UserLoginDetailsV2`,

      //  return this.httpClient.get<Array<PatientPortalLoggedInUserList>>(`${this.basePath}/GetUsers`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    public UpdateDisclaimerStatus(userId: number, showDisclaimer: boolean, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            //formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }
        if (userId !== undefined) {
            formParams = formParams.append('userId', <any>userId) || formParams;
        }
        if (showDisclaimer !== undefined) {
            formParams = formParams.append('showDisclaimer', <any>showDisclaimer) || formParams;
        }
        return this.httpClient.post<any>(`${this.basePath}/UpdateDisclaimerStatus`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    public getUsersbyPatientId(userEmail: string, practiceCode: string, patientId:number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (userEmail !== undefined && userEmail !== null) {
            queryParameters = queryParameters.set('userEmail', <any>userEmail);
        }
        if (patientId !== undefined && patientId !== null) {
            queryParameters = queryParameters.set('patientId', <any>patientId);
        }
        if (practiceCode !== undefined && practiceCode !== null) {
            queryParameters = queryParameters.set('practiceCode', <any>practiceCode);
        }

        let headers = new HttpHeaders();
        //headers = headers.set('Access-Control-Allow-Origin', '*');
        //headers = headers.set('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE,PATCH,OPTIONS');
        //headers = headers.set('Access-Control-Allow-Headers', 'Content-Type, Accept');
        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        //////MMDRD
        // return this.httpClient.get<Array<PatientPortalLoggedInUserList>>(`${this.basePath}/UserLoginDetails`,

        return this.httpClient.get<Array<PatientPortalLoggedInUserList>>(`${this.basePath}/GetUsersbyPatientId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public getLoggedInPatientDetails(isAzure: boolean, loggedInpatients: any, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let apipath = environment.appSetting.apiUrl + 'patientportal';
        if (isAzure) {
            apipath = environment.appSetting.azureapiUrl + 'patientportal';
        }
        let headers = new HttpHeaders();
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post<Array<PatientPortalLoggedInUserList>>(`${apipath}/LoggedInPatientDetails`,
            loggedInpatients,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
